import type { NavImpactSurfaces } from '../arms';

export const spec = (): Partial<NavImpactSurfaces> => ({
  barStyle: 'whole_bar',
  statStyle: 'plain',
  statLayout: 'inline',
});
